module.exports = __webpack_public_path__ + "img/download-appstore.d119e0c2.svg";